// reducer.js
import {
  CANDIDATE_BULK_EXCEL_UPLOAD_REQUEST,
  CANDIDATE_BULK_EXCEL_UPLOAD_SUCCESS,
  CANDIDATE_BULK_EXCEL_UPLOAD_FAILURE,
  CANDIDATE_BULK_EXCEL_UPLOAD_RESET,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  status: false,
  parsed_resumes: null,
  message: "",
  results: [],
};

const candidateBulkExcelUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_BULK_EXCEL_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CANDIDATE_BULK_EXCEL_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
        parsed_resumes: action.payload.parsed_resumes,
        results: action.payload.results || [],
      };
    case CANDIDATE_BULK_EXCEL_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        message: action.payload?.message || "Upload failed",
        status: false,
        parsed_resumes: action.payload?.parsed_resumes,
      };
    case CANDIDATE_BULK_EXCEL_UPLOAD_RESET:
      return {
        ...state,
        isLoading: false,
        status: false,
        message: "",
        results: [],
        parsed_resumes: null,
      };
    default:
      return state;
  }
};

export default candidateBulkExcelUploadReducer;
